
const LOCAL_STORAGE_WISHLIST_KEY = 'shopify-wishlist';
const LOCAL_STORAGE_DELIMITER = ',';
const BUTTON_ACTIVE_CLASS = 'active';
const GRID_LOADED_CLASS = 'loaded';

const selectorswish = {
  button: '[button-wishlist]',
  grid: '[grid-wishlist]',
  productCard: '.grid__item',
  wishlistCount: '[data-js-wishlist-count]',
  wishlistText: '.wishlist-text'
};

document.addEventListener('DOMContentLoaded', () => {
  const relatedProducts = document.getElementsByClassName("related-products");
  if (!relatedProducts.length) initButtons();
  initGrid();
  updateWishlistCount();
});

document.addEventListener('shopify-wishlist:updated', () => {
  initGrid();
});

document.addEventListener('shopify-wishlist:init-product-grid', (event) => {
  // Optional: console.log('Wishlist Grid Initialized', event.detail.wishlist);
});

document.addEventListener('shopify-wishlist:init-buttons', (event) => {
  // Optional: console.log('Wishlist Buttons Initialized', event.detail.wishlist);
});

const fetchProductCardHTML = (handle) => {
  const productTileTemplateUrl = `/products/${handle}?view=wish`;
  return fetch(productTileTemplateUrl)
    .then((res) => res.text())
    .then((res) => {
      const parser = new DOMParser();
      const htmlDocument = parser.parseFromString(res, 'text/html');
      const productCard = htmlDocument.querySelector(selectorswish.productCard);
      return productCard ? productCard.outerHTML : '';
    })
    .catch((err) => console.error(`[Shopify Wishlist] Failed to load content for handle: ${handle}`, err));
};

const setupGrid = async (grid) => {
  const wishlist = getWishlist();
  const responses = await Promise.all(wishlist.map(fetchProductCardHTML));
  grid.innerHTML = responses.join('');
  grid.classList.add(GRID_LOADED_CLASS);
  initButtons();

  const event = new CustomEvent('shopify-wishlist:init-product-grid', {
    detail: { wishlist: wishlist }
  });
  document.dispatchEvent(event);
};

const setupButtons = (buttons) => {
  buttons.forEach((button) => {
    const productHandle = button.dataset.productHandle || false;
    button.classList.toggle('iniactive');
    if (!productHandle) return console.error('[Shopify Wishlist] Missing `data-product-handle` attribute.');
    if (wishlistContains(productHandle)) button.classList.add(BUTTON_ACTIVE_CLASS);

    button.addEventListener('click', () => {
      updateWishlist(productHandle);
      button.classList.toggle(BUTTON_ACTIVE_CLASS);
    });
  });
};

const initGrid = () => {
  const grid = document.querySelector(selectorswish.grid);
  if (grid) setupGrid(grid);
};

const initButtons = () => {
  const buttons = document.querySelectorAll(selectorswish.button);
  if (buttons.length) setupButtons(buttons);

  const event = new CustomEvent('shopify-wishlist:init-buttons', {
    detail: { wishlist: getWishlist() }
  });
  document.dispatchEvent(event);
};

const getWishlist = () => {
  const wishlist = localStorage.getItem(LOCAL_STORAGE_WISHLIST_KEY);
  return wishlist ? wishlist.split(LOCAL_STORAGE_DELIMITER) : [];
};

const setWishlist = (array) => {
  const wishlist = array.join(LOCAL_STORAGE_DELIMITER);
  if (array.length) localStorage.setItem(LOCAL_STORAGE_WISHLIST_KEY, wishlist);
  else localStorage.removeItem(LOCAL_STORAGE_WISHLIST_KEY);

  const event = new CustomEvent('shopify-wishlist:updated', {
    detail: { wishlist: array }
  });
  document.dispatchEvent(event);
  updateWishlistCount();
  return wishlist;
};

const updateWishlist = (handle) => {
  const wishlist = getWishlist();
  const indexInWishlist = wishlist.indexOf(handle);
  if (indexInWishlist === -1) wishlist.push(handle);
  else wishlist.splice(indexInWishlist, 1);
  return setWishlist(wishlist);
};

const wishlistContains = (handle) => {
  const wishlist = getWishlist();
  return wishlist.includes(handle);
};

const resetWishlist = () => {
  return setWishlist([]);
};

const updateWishlistCount = () => {
  const wishlist = getWishlist();

  const countElements = document.querySelectorAll(selectorswish.wishlistCount);
  countElements.forEach((el) => {
    el.setAttribute('data-js-wishlist-count', wishlist.length);
    el.innerText = wishlist.length;
  });

  const textElement = document.querySelector(selectorswish.wishlistText);
  if (textElement) {
    textElement.style.display = wishlist.length === 0 ? "block" : "none";
  }
};

